import { useServerData, LIST_MIN_LOADING_MS } from '@/hooks/useServerData';
import { AgencyDashboardService } from '@/services/agencyDashboard.service';
import {
    AgencyTripRow,
    AgencyTripsQuery,
    AgencyTripsSummary,
} from '@/integrations/supabase/rpc-types';

/**
 * Una pagina della lista viaggi. Filtri e paginazione stanno nel database: la lista puo'
 * essere lunga e la tab carica solo cio' che mostra. La ricerca arriva gia' con il
 * debounce applicato dal chiamante, condiviso con i contatori. `refreshKey` cambiato =
 * ricarica con gli stessi filtri.
 */
export function useAgencyTrips(query: AgencyTripsQuery, refreshKey: number) {
    const state = useServerData<AgencyTripRow[]>(
        JSON.stringify({ query, refreshKey }),
        [],
        () => AgencyDashboardService.getTrips(query),
        true,
        LIST_MIN_LOADING_MS
    );
    // Righe della vista filtrata prima della paginazione: la RPC lo ripete su ogni riga.
    return { ...state, totalCount: state.data[0]?.total_count ?? 0 };
}

/**
 * Contatori della tab Viaggi. Chiamata separata dalla lista perche' ignora la categoria:
 * cambiare contatore non deve ricaricarli, cambiare periodo, consulente o ricerca si'.
 */
export function useAgencyTripsSummary(
    query: Pick<AgencyTripsQuery, 'period' | 'designerId' | 'search'>,
    refreshKey: number
) {
    return useServerData<AgencyTripsSummary | null>(
        JSON.stringify({ query, refreshKey }),
        null,
        () => AgencyDashboardService.getTripsSummary(query),
        true,
        0,
        // L'errore lo segnala gia' la lista, che parte in parallelo con gli stessi
        // filtri: un secondo toast direbbe la stessa cosa.
        false
    );
}

export default useAgencyTrips;
